import _asyncToGenerator from "E:/guanwnag/hzzn.group.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.json.stringify.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c4ed42f0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "buy-service-box"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "buy-title"
  }, "购买软件", -1);
});

var _hoisted_3 = {
  class: "service-content-box hidden-scroll"
};
var _hoisted_4 = {
  class: "service-content"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "短视频软件", -1);
});

var _hoisted_6 = {
  class: "btn-box"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "service-content"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "数字人直播软件", -1);
});

var _hoisted_10 = {
  class: "btn-box"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "more-box"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "more-title"
  }, "登录", -1);
});

var _hoisted_14 = {
  class: "code-box"
};
var _hoisted_15 = {
  class: "buy-service-box"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "buy-title"
  }, "确认订单", -1);
});

var _hoisted_17 = {
  class: "service-content"
};
var _hoisted_18 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_19 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_20 = {
  style: {
    "display": "flex",
    "algin-items": "center",
    "justify-content": "space-between"
  }
};
var _hoisted_21 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_22 = {
  key: 0,
  class: "qr-code",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "支持微信扫码支付", -1);
});

import { reactive, ref } from 'vue';
import { loginPhone, userLoginMobileCode, videoDistributeOrder, pay } from '@api/user/login';
import store from '@/store';
import { NModal, NForm, NFormItem, NInput } from 'naive-ui';
import QrcodeVue from 'qrcode.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    showCollModal: {
      type: Boolean,
      default: false
    },
    businessType: {
      default: ''
    }
  },
  emits: ['closeDialog'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props; // props: {
    //   showCollModal: {
    //     type: Boolean,
    //     default: false
    //   },
    //   businessType: {
    //     type: String,
    //     default: '',
    //   }
    // }

    var formRef = ref();
    var state = reactive({
      serviceList: [{
        title: '免费版',
        productId: 217,
        money: 0,
        liContent: ['合成时长: 30秒试用时长', '页数限制', '数字人部分免费', '声音免费', '模板部分免费', '100+张背景、插图免费', '导入PPT制作免费', '储存空间: 1G', '视频分辨率: 1080P']
      }, {
        title: '月卡',
        productId: 219,
        money: 298,
        liContent: ['合成时长: 30分钟', '页数不限制', '支持视频轨道编辑器', '60+真人、3D数字人免费', '500+声音免费', '30+模板免费', '100+张背景、插图免费', '导入PPT制作免费', '储存空间: 30G', '视频分辨率: 1080P']
      }, {
        title: '年卡',
        productId: 221,
        money: 2499,
        liContent: ['合成时长: 360分钟', '页数不限制', '支持视频轨道编辑器', '60+真人、3D数字人免费', '500+声音免费', '30+模板免费', '100+张背景、插图免费', '导入PPT制作免费', '储存空间: 30G', '视频分辨率: 1080P']
      }],
      serviceTwoList: [{
        title: '月卡',
        productId: 223,
        money: 4999,
        liContent: ['实时驱动、自动播', '合成时长: 500分钟', '60+真人、3D数字人免费', '500+声音免费', '30+模板免费', '100+张背景、插图免费', '导入PPT制作免费', '储存空间: 30G', '视频分辨率: 1080P', '支持真人驱动直播']
      }, {
        title: '年卡',
        productId: 225,
        money: 9999,
        liContent: ['实时驱动、自动播', '合成时长: 1500分钟', '60+真人、3D数字人免费', '500+声音免费', '30+模板免费', '100+张背景、插图免费', '导入PPT制作免费', '储存空间: 30G', '视频分辨率: 1080P', '支持真人驱动直播']
      }],
      showOrder: false,
      orderInfo: {},
      showLogin: false,
      formData: {
        phone: '',
        code: '',
        randomStr: Math.floor(Math.random() * 1000)
      },
      rules: {
        phone: {
          required: true,
          trigger: ['input'],
          validator: function validator(rule, value) {
            if (!value) {
              return new Error('手机号不能为空');
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              return new Error('请输入正确的手机号');
            }

            return true;
          }
        },
        code: {
          required: true,
          trigger: ['input'],
          message: '输入验证码'
        }
      },
      disabledFlag: false,
      codeText: '获取验证码',
      pageQrCode: ''
    });

    var handelClose = function handelClose() {
      state.formData = {
        phone: '',
        code: '',
        randomStr: Math.floor(Math.random() * 1000)
      };
      state.disabledFlag = false;
    };

    var updateCollModal = function updateCollModal(v) {
      emit('closeDialog');
    };

    function handleBuy(item) {
      state.orderInfo = item;

      if (localStorage.getItem('hzhyService-isLogin')) {
        if (store.getters.access_token) {
          buy();
        } else {
          state.showLogin = true;
        }
      } else {
        state.showLogin = true;
      }
    }

    function buy() {
      var params = {
        accountMatrixId: 3,
        location: null,
        planId: 3,
        productIdList: [state.orderInfo.productId],
        quantity: 1,
        taskId: '',
        trainId: null,
        videoDistributeId: 3
      };

      if (state.orderInfo.money) {
        videoDistributeOrder(params).then(function (data) {
          if (!data || !data.orderId) return;
          pay(data.orderId).then(function (content) {
            state.pageQrCode = content.codeUrl;
            state.showOrder = true;
          });
        });
      } else {
        state.pageQrCode = '';
        state.showOrder = true;
      }
    }

    var timer = null;

    var checkPhone = function checkPhone(value) {
      return /^1[3456789]\d{9}$/.test(value);
    };

    function countDown() {
      return _countDown.apply(this, arguments);
    }

    function _countDown() {
      _countDown = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var t;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = 60;
                timer = setInterval(function () {
                  --t;
                  state.codeText = "\u5012\u8BA1\u65F6".concat(t, "S");

                  if (!t) {
                    t = 60;
                    state.codeText = '获取验证码';
                    state.disabledFlag = false;
                    clearInterval(timer);
                  }
                }, 1000);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _countDown.apply(this, arguments);
    }

    function handleMobileCode() {
      if (!checkPhone(state.formData.phone) || state.disabledFlag) return;
      loginMobileCode();
    }

    function loginMobileCode() {
      userLoginMobileCode(state.formData.phone).then(function (data) {
        if (!data) return;
        state.disabledFlag = true;
        countDown();
        var f = window;
        f.$message.success('验证已发送请查收');
      });
    }

    var submitForm = function submitForm(e) {
      var _formRef$value;

      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(errors) {
          var loginData;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (errors) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 3;
                  return loginPhone(state.formData);

                case 3:
                  loginData = _context.sent;

                  if (loginData) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return");

                case 6:
                  _context.next = 8;
                  return store.dispatch('updateUserStorage', loginData);

                case 8:
                  store.dispatch('updateTenant', String(loginData.user_info.tenantId));
                  localStorage.setItem('hzhyService-isLogin', JSON.stringify({
                    isLogin: true
                  }));
                  state.showLogin = false;
                  buy();
                  _context.next = 14;
                  break;

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    };

    return function (_ctx, _cache) {
      var _component_n_button = _resolveComponent("n-button");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(NModal), {
        to: "body",
        "display-directive": 'if',
        show: __props.showCollModal,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(showCollModal) ? showCollModal.value = $event : null;
        }),
        "on-update:show": updateCollModal,
        preset: "dialog",
        "auto-focus": false,
        style: {
          "width": "800px",
          "min-width": "450px",
          "padding": "55px 64px",
          "--n-content-margin": "0"
        },
        showIcon: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).serviceList, function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              key: index
            }, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("p", null, "￥" + _toDisplayString(item.money) + _toDisplayString(item.title === '月卡' ? '/月' : item.title === '年卡' ? '/年' : ''), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
              onClick: _withModifiers(function ($event) {
                return handleBuy(item);
              }, ["stop", "prevent"]),
              class: "btn btn-confirm"
            }, " 立刻购买 ", 8, _hoisted_7)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.liContent, function (item) {
              return _openBlock(), _createElementBlock("span", {
                key: item
              }, _toDisplayString(item), 1);
            }), 128))]);
          }), 128))])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).serviceTwoList, function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              key: index
            }, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("p", null, "￥" + _toDisplayString(item.money) + _toDisplayString(item.title === '月卡' ? '/月' : '/年'), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
              onClick: _withModifiers(function ($event) {
                return handleBuy(item);
              }, ["stop", "prevent"]),
              class: "btn btn-confirm"
            }, " 立刻购买 ", 8, _hoisted_11)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.liContent, function (item) {
              return _openBlock(), _createElementBlock("span", {
                key: item
              }, _toDisplayString(item), 1);
            }), 128))]);
          }), 128))])])])])];
        }),
        _: 1
      }, 8, ["show"]), _createVNode(_unref(NModal), {
        to: "body",
        "display-directive": 'if',
        show: _unref(state).showLogin,
        "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
          return _unref(state).showLogin = $event;
        }),
        preset: "dialog",
        "auto-focus": false,
        style: {
          "width": "29.5vw",
          "min-width": "450px",
          "padding": "55px 64px 20px 64px",
          "--n-content-margin": "0"
        },
        showIcon: false,
        "on-after-leave": handelClose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_unref(NForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-width": 80,
            model: _unref(state).formData,
            rules: _unref(state).rules,
            "label-placement": "left",
            "require-mark-placement": "left",
            style: {
              maxWidth: '640px'
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(NFormItem), {
                label: "",
                path: "phone"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(NInput), {
                    autofocus: false,
                    maxlength: "11",
                    value: _unref(state).formData.phone,
                    "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(state).formData.phone = $event;
                    }),
                    placeholder: "请填写您的手机号码",
                    onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["value"])];
                }),
                _: 1
              }), _createVNode(_unref(NFormItem), {
                label: "",
                path: "code"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_14, [_createVNode(_unref(NInput), {
                    value: _unref(state).formData.code,
                    "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(state).formData.code = $event;
                    }),
                    placeholder: "请输入验证码",
                    clearable: "",
                    maxlength: "4"
                  }, null, 8, ["value"]), _createVNode(_component_n_button, {
                    size: "large",
                    type: "primary",
                    class: "code-btn",
                    disabled: _unref(state).disabledFlag,
                    onClick: _withModifiers(handleMobileCode, ["stop", "prevent"])
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(state).codeText), 1)];
                    }),
                    _: 1
                  }, 8, ["disabled", "onClick"])])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model", "rules"]), _createElementVNode("div", {
            class: "btn-box"
          }, [_createElementVNode("div", {
            onClick: submitForm,
            class: "btn btn-confirm"
          }, "登录")])])];
        }),
        _: 1
      }, 8, ["show"]), _createVNode(_unref(NModal), {
        to: "body",
        "display-directive": 'if',
        show: _unref(state).showOrder,
        "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
          return _unref(state).showOrder = $event;
        }),
        preset: "dialog",
        "auto-focus": false,
        style: {
          "width": "480px",
          "min-width": "480px",
          "padding": "55px 64px",
          "--n-content-margin": "0"
        },
        showIcon: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("li", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", null, "商品名称：" + _toDisplayString(_unref(state).orderInfo.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).orderInfo.liContent, function (item) {
            return _openBlock(), _createElementBlock("span", {
              key: item
            }, _toDisplayString(item), 1);
          }), 128)), _createElementVNode("span", null, "订单总额：" + _toDisplayString(_unref(state).orderInfo.money) + ".00元", 1)]), _unref(state).orderInfo.money ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(QrcodeVue, {
            id: 34345,
            value: _unref(state).pageQrCode,
            size: 90,
            level: "L"
          }, null, 8, ["value"]), _hoisted_23])) : _createCommentVNode("", true)])])])])])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});